export default __webpack_public_path__ + "static/media/greykeep.1ef876d8.png";